<template>
  <div>
    <!-- <navigation /> -->
    <backgroundImage />
    <div class="new-user-overlay">
      <div class="new-user-overlay-content">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="icon icon-tabler icon-tabler-shield-lock"
          width="100"
          height="100"
          viewBox="0 0 24 24"
          stroke-width="0.5"
          stroke="#00424a"
          fill="none"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <path stroke="none" d="M0 0h24v24H0z" fill="none" />
          <path
            d="M12 3a12 12 0 0 0 8.5 3a12 12 0 0 1 -8.5 15a12 12 0 0 1 -8.5 -15a12 12 0 0 0 8.5 -3"
          />
          <circle cx="12" cy="11" r="1" />
          <line x1="12" y1="12" x2="12" y2="14.5" />
        </svg>

        <div class="new-user-overlay__text">
          Hello {{ userName }}!! <br />
          You don’t have permission to view any of the Admin Pages <br />
          Please contact the admin to get access.
          <span class="signout-button" @click="signOutClickHandler"
            >Sign Out</span
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import backgroundImage from "../../components/helperComponents/background-image";
// import navigation from "../../components/helperComponents/menu";

export default {
  components: {
    backgroundImage,
  },
  data() {
    return {
      userName:
        window.gapi.auth2
          .getAuthInstance()
          .currentUser.get()
          .getBasicProfile()
          .getName() || "",
    };
  },
  methods: {
    signOutClickHandler() {
      this.$router.push({ name: "login" });
    },
  },
};
</script>

<style>
.new-user-overlay {
  justify-content: center;
  width: 100%;
  height: 100%;
  position: fixed;
  background-color: rgba(245, 245, 245, 0.6);
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  z-index: 1000;
}

.signout-button {
  font-size: 14px;
  color: #00424a;
  text-decoration: underline;
  cursor: pointer;
}

.new-user-overlay-content {
  display: inline-block;
  margin: 0 auto;
  max-width: 982px;
  background-color: #fff;
  box-sizing: border-box;
  padding: 32px 100px;
  font-size: 18px;
  line-height: 30px;
  border-radius: 8px;
  text-align: center;
}
</style>
